import React, { useState, useRef, useEffect, useCallback } from 'react';
import '../../../styles/style.css';

const PhotoGallery = ({ photos = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const wrapperRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  // Функция прокрутки — максимально простая и прямая
  const scrollToIndex = useCallback((index) => {
    if (!wrapperRef.current) return;
    
    // Очищаем предыдущий таймаут
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }
    
    // Даём React время на обновление DOM
    scrollTimeoutRef.current = setTimeout(() => {
      const container = wrapperRef.current;
      if (!container) return;
      
      // Ищем фото по data-атрибуту — самый надёжный способ
      const targetPhoto = container.querySelector(`[data-index="${index}"]`);
      
      if (targetPhoto) {
        const containerRect = container.getBoundingClientRect();
        const targetRect = targetPhoto.getBoundingClientRect();
        const scrollLeft = targetPhoto.offsetLeft - (containerRect.width / 2) + (targetRect.width / 2);
        
        container.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: 'smooth'
        });
      }
    }, 10);
  }, []);

  // При изменении индекса — прокручиваем
  useEffect(() => {
    scrollToIndex(currentIndex);
  }, [currentIndex, scrollToIndex]);

  // Обработчики кликов — максимально простые
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < photos.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  // Очистка таймаута при размонтировании
  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  if (!photos || photos.length === 0) {
    return null;
  }

  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex < photos.length - 1;

  return (
    <div className="locationPhotosViewerWrapper flex-column">
      <div className="photoSlideArrowsWrapper flex-row">
        <img 
          className={`photoSlideArrows arrow-left ${!hasPrev ? 'disabled' : ''}`} 
          src="/elements/arrowLeft.svg" 
          alt="Предыдущее фото"
          onClick={handlePrev}
          style={{ cursor: hasPrev ? 'pointer' : 'not-allowed' }}
        />
        <img 
          className={`photoSlideArrows arrow-right ${!hasNext ? 'disabled' : ''}`} 
          src="/elements/arrowRight.svg" 
          alt="Следующее фото"
          onClick={handleNext}
          style={{ cursor: hasNext ? 'pointer' : 'not-allowed' }}
        />
      </div>
      
      <div className="locationPhotosWrapper flex-row" ref={wrapperRef}>
        {photos.map((photo, index) => (
          <img 
            key={index}
            data-index={index}  // data-атрибут для надёжного поиска
            className={`locationPhoto ${index === currentIndex ? 'active' : ''}`}
            src={photo}
            alt={`Фото локации ${index + 1}`}
          />
        ))}
      </div>
      
      <div className="photoIndicators flex-row">
        {photos.map((_, index) => (
          <div 
            key={index}
            className={`photoIndicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default PhotoGallery;